import "./EarningsBlock.css";

const levels = [
  {
    level: "Начальный",
    income: "60 000 - 90 000 ₽",
    period: "в месяц",
    accent: "Старт после обучения",
    points: [
      "Выполнение типовых проектов",
      "Работа в команде производства",
      "Рост за счет скорости и качества",
    ],
  },
  {
    level: "Средний",
    income: "100 000 - 150 000 ₽",
    period: "в месяц",
    accent: "Уверенный специалист",
    points: [
      "Самостоятельные проекты под ключ",
      "Оптимизация конструкций и технологий",
      "Удаленнаяя работа",
    ],
  },
  {
    level: "Профи",
    income: "от 180 000 ₽",
    period: "в месяц",
    accent: "Экспертный уровень",
    points: [
      "Сложные и нестандартные задачи",
      "Ведение нескольких проектов",
      "Переход в управленческие роли",
    ],
  },
];

const growthRoles = [
  "Руководитель конструкторского отдела",
  "Главный технолог",
  "Начальник производства",
  "Ведущий конструктор",
  "Руководитель проекта",
];

const jobRoles = [
  "Стажер-конструктор",
  "Конструктор мебельного производства",
  "Технолог мебельного производства",
];

const altUseCases = [
  "Проектирование мебели для себя и близких",
  "Понимание устройства мебели и принципов её работы",
  "Понимание рынка и сегментов мебельного бизнеса",
  "Разработка мебели для продажи (собственные изделия, маркетплейсы)",
];

function EarningsBlock() {
  return (
    <section className="earnings" id="income">
      <div className="earnings__container">
        <p className="earnings__label">Доход и рост</p>
        <h2 className="earnings__title">
          Сколько зарабатывает конструктор-технолог мебели
        </h2>
        <p className="earnings__subtitle">
          Доход зависит от региона, нагрузки и уровня проектов. Ниже ориентиры
          по трем ступеням развития в профессии.
        </p>

        <div className="earnings__grid">
          {levels.map((item) => (
            <article className="earnings__card" key={item.level}>
              <p className="earnings__level">{item.level}</p>
              <p className="earnings__income">{item.income}</p>
              <p className="earnings__period">{item.period}</p>
              <p className="earnings__accent">{item.accent}</p>
              <ul className="earnings__list">
                {item.points.map((point) => (
                  <li className="earnings__item" key={point}>
                    {point}
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>

        <div className="earnings__tracks">
          <div className="earnings__roles">
            <p className="earnings__roles-title">
              Кем можно работать после курса:
            </p>
            <ul className="earnings__roles-list">
              {jobRoles.map((role) => (
                <li className="earnings__roles-item" key={role}>
                  {role}
                </li>
              ))}
            </ul>
          </div>

          <div className="earnings__roles">
            <p className="earnings__roles-title">Куда расти дальше:</p>
            <ul className="earnings__roles-list">
              {growthRoles.map((role) => (
                <li className="earnings__roles-item" key={role}>
                  {role}
                </li>
              ))}
            </ul>
          </div>

          <div className="earnings__roles">
            <p className="earnings__roles-title">
              Где применить знания помимо работы конструктором:
            </p>
            <ul className="earnings__roles-list">
              {altUseCases.map((role) => (
                <li className="earnings__roles-item" key={role}>
                  {role}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export default EarningsBlock;
